export const enum cardType {
  TAKE = 'TAKE',
  GIVE = 'GIVE'
}
